import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import FileList from "./FileList";

export interface Props {}

const useStyles = makeStyles({
  container: {
    margin: "10px",
  },
});

const FileExplorer: React.FC<Props> = ({}: Props) => {
  const styles = useStyles();

  return (
    <section className={styles.container}>
      <FileList level={1} path={"/"} />
    </section>
  );
};

export default FileExplorer;
